import bsAppStrings from 'Translations/lang-bs.json'
import csAppStrings from 'Translations/lang-cs.json'
import deAppStrings from 'Translations/lang-de.json'
import elAppStrings from 'Translations/lang-el.json'
import enAppStrings from 'Translations/lang-en.json'
import hrAppStrings from 'Translations/lang-hr.json'
import huAppStrings from 'Translations/lang-hu.json'
import itAppStrings from 'Translations/lang-it.json'
import plAppStrings from 'Translations/lang-pl.json'
import roAppStrings from 'Translations/lang-ro.json'
import srAppStrings from 'Translations/lang-sr.json'
import skAppStrings from 'Translations/lang-sk.json'
import slAppStrings from 'Translations/lang-sl.json'
import sqAppStrings from 'Translations/lang-sq.json'


// translations for bank specific strings in english
import nexiAppStrings from 'Translations/bank/lang-nexi.json'
import uciAppStrings from 'Translations/bank/lang-uci.json'
import ispAppStrings from 'Translations/bank/lang-isp.json'

/* Language codes:
  bs='bosniaco',
  cs='ceco',
  de='tedesco',
  el='greco',
  en='inglese',
  hr='croato',
  hu='ungherese',
  it='italiano',
  pl='polacco',
  ro='rumeno',
  sk='slovacco',
  sl='sloveno',
  sq='albanese',
  sr='serbo',
*/

export const bankTranslationMessages = {
  nexi: {
    bs: { momentLocale: 'bs', appStrings: { ...nexiAppStrings, ...bsAppStrings } },
    cs: { momentLocale: 'cs', appStrings: { ...nexiAppStrings, ...csAppStrings } },
    de: { momentLocale: 'de', appStrings: { ...nexiAppStrings, ...deAppStrings } },
    el: { momentLocale: 'el', appStrings: { ...nexiAppStrings, ...elAppStrings } },
    en: { momentLocale: 'en-gb', appStrings: { ...nexiAppStrings, ...enAppStrings } },
    hr: { momentLocale: 'hr', appStrings: { ...nexiAppStrings, ...hrAppStrings } },
    hu: { momentLocale: 'hu', appStrings: { ...nexiAppStrings, ...huAppStrings } },
    it: { momentLocale: 'it', appStrings: { ...nexiAppStrings, ...itAppStrings } },
    pl: { momentLocale: 'pl', appStrings: { ...nexiAppStrings, ...plAppStrings } },
    ro: { momentLocale: 'ro', appStrings: { ...nexiAppStrings, ...roAppStrings } },
    sk: { momentLocale: 'sk', appStrings: { ...nexiAppStrings, ...skAppStrings } },
    sl: { momentLocale: 'sl', appStrings: { ...nexiAppStrings, ...slAppStrings } },
    sq: { momentLocale: 'sq', appStrings: { ...nexiAppStrings, ...sqAppStrings } },
    sr: { momentLocale: 'sr', appStrings: { ...nexiAppStrings, ...srAppStrings } }
  },
  'unicredit-e-platform': {
    bs: { momentLocale: 'bs', appStrings: { ...uciAppStrings, ...bsAppStrings } },
    cs: { momentLocale: 'cs', appStrings: { ...uciAppStrings, ...csAppStrings } },
    de: { momentLocale: 'de', appStrings: { ...uciAppStrings, ...deAppStrings } },
    el: { momentLocale: 'el', appStrings: { ...uciAppStrings, ...elAppStrings } },
    en: { momentLocale: 'en-gb', appStrings: { ...uciAppStrings, ...enAppStrings } },
    hr: { momentLocale: 'hr', appStrings: { ...uciAppStrings, ...hrAppStrings } },
    hu: { momentLocale: 'hu', appStrings: { ...uciAppStrings, ...huAppStrings } },
    it: { momentLocale: 'it', appStrings: { ...uciAppStrings, ...itAppStrings } },
    pl: { momentLocale: 'pl', appStrings: { ...uciAppStrings, ...plAppStrings } },
    ro: { momentLocale: 'ro', appStrings: { ...uciAppStrings, ...roAppStrings } },
    sk: { momentLocale: 'sk', appStrings: { ...uciAppStrings, ...skAppStrings } },
    sl: { momentLocale: 'sl', appStrings: { ...uciAppStrings, ...slAppStrings } },
    sq: { momentLocale: 'sq', appStrings: { ...uciAppStrings, ...sqAppStrings } },
    sr: { momentLocale: 'sr', appStrings: { ...uciAppStrings, ...srAppStrings } }
  },
  isp: {
    bs: { momentLocale: 'bs', appStrings: { ...ispAppStrings, ...bsAppStrings } },
    cs: { momentLocale: 'cs', appStrings: { ...ispAppStrings, ...csAppStrings } },
    de: { momentLocale: 'de', appStrings: { ...ispAppStrings, ...deAppStrings } },
    el: { momentLocale: 'el', appStrings: { ...ispAppStrings, ...elAppStrings } },
    en: { momentLocale: 'en-gb', appStrings: { ...ispAppStrings, ...enAppStrings } },
    hr: { momentLocale: 'hr', appStrings: { ...ispAppStrings, ...hrAppStrings } },
    hu: { momentLocale: 'hu', appStrings: { ...ispAppStrings, ...huAppStrings } },
    it: { momentLocale: 'it', appStrings: { ...ispAppStrings, ...itAppStrings } },
    pl: { momentLocale: 'pl', appStrings: { ...ispAppStrings, ...plAppStrings } },
    ro: { momentLocale: 'ro', appStrings: { ...ispAppStrings, ...roAppStrings } },
    sk: { momentLocale: 'sk', appStrings: { ...ispAppStrings, ...skAppStrings } },
    sl: { momentLocale: 'sl', appStrings: { ...ispAppStrings, ...slAppStrings } },
    sq: { momentLocale: 'sq', appStrings: { ...ispAppStrings, ...sqAppStrings } },
    sr: { momentLocale: 'sr', appStrings: { ...ispAppStrings, ...srAppStrings } }
  }
}
